import type { ReactNode } from 'react';
import { LucideProvider } from 'lucide-react';

/**
 * Traço padrão dos ícones Lucide do painel: 1,5, como manda o livro de marca
 * (capítulo 8). Sem o provider, todo ícone sem `strokeWidth` sai com o 2 da
 * biblioteca. Quem passa `strokeWidth` explícito vence o padrão, e é assim que
 * ficam as exceções nomeadas do livro: 2 em seta e chip de 12 px, 2,5 no
 * spinner do botão. Peças de QR (`features/qrcode`) têm traço em mm e não são
 * ícones Lucide.
 */
export function IconDefaults({ children }: { children: ReactNode }) {
  return <LucideProvider strokeWidth={1.5}>{children}</LucideProvider>;
}
